// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Vertical padding */
@media (min-width: 960px) {
  .header {
    padding-top: 0 !important;
  }
}
@media (min-width: 720px) {
  .btn.btn--text-link.quick-cart__item-remove {
    margin-left: auto;
  }
}
.header__logo {
  margin-top: 2px !important;
  margin-bottom: 0 !important;
  padding-top: var(--mobile-padding-size, 0);
  padding-bottom: var(--mobile-padding-size, 0);
  /* Correct logo (light or dark) will be show when backgorund image color will be inspected trough javascript */
}
.header__logo.header--vertical-padding-none {
  padding-top: 0;
  padding-bottom: 0;
}
.header__logo.header--vertical-padding-top-only {
  padding-bottom: 0;
}
.header__logo.header--vertical-padding-bottom-only {
  padding-top: 0;
}
.header__logo .regular-logo {
  display: none;
}
.header__logo .logo-visible {
  display: block;
}

/* Always show dark logo if sticky header */
header:hover .header__logo .logo-visible {
  display: none;
}
header:hover .header__logo .regular-logo.dark {
  display: block;
}

header.is-sticky .header__logo .logo-visible {
  display: none;
}
header.is-sticky .header__logo .regular-logo.dark {
  display: block;
}

@media (min-width: 960px) {
  .header__logo {
    padding-top: var(--padding-size, 0);
    padding-bottom: var(--padding-size, 0);
  }
}
.header .drawer-menu .drawer-menu__bottom .drawer-menu__contents .header__links-compact-menu-left {
  display: none;
}

@media (min-width: 960px) {
  .header.header--layout-logo-center-compact-menu-left .header__row.header__row-desktop {
    display: none;
  }
  .header.header--layout-logo-center-compact-menu-left .header__row.header__row-mobile {
    display: grid;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__bottom {
    max-width: var(--max-width);
    margin: auto;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__panel {
    background: transparent;
    padding-top: var(--height-header);
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu #localization_form {
    display: none;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents {
    overflow: hidden;
    height: 50%;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left {
    display: block;
    height: unset;
    background: var(--color-background);
    width: 17%;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left .header__links-list {
    flex-direction: column;
    align-items: flex-start;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left .header__links-list > li {
    width: 90%;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left .header__links-list > li > button,
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left .header__links-list > li > a {
    color: black;
    width: 100%;
    padding-left: 20px;
    justify-content: space-between;
    z-index: 1;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left .header__links-list > li > button .header__links-icon,
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left .header__links-list > li > a .header__links-icon {
    transform: rotate(270deg);
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .header__links-compact-menu-left .meganav {
    top: 0;
    left: 17% !important;
    transform: unset;
    border: none;
    margin-left: -17%;
    padding-left: 17%;
  }
  .header.header--layout-logo-center-compact-menu-left .drawer-menu .drawer-menu__contents .drawer-menu__main {
    height: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/header.scss"],"names":[],"mappings":"AAEA,qBAAA;AACA;EACE;IACE,yBAAA;EADF;AACF;AAIA;EACE;IACE,iBAAA;EAFF;AACF;AAKA;EACE,0BAAA;EACA,2BAAA;EACA,0CAAA;EACA,6CAAA;EAeA,8GAAA;AAjBF;AAIE;EACE,cAAA;EACA,iBAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAQE;EACE,aAAA;AANJ;AASE;EACE,cAAA;AAPJ;;AAWA,2CAAA;AAGI;EACE,aAAA;AAVN;AAcM;EACE,cAAA;AAZR;;AAMI;EACE,aAAA;AAHN;AAOM;EACE,cAAA;AALR;;AAqBA;EACE;IACE,mCAAA;IACA,sCAAA;EAlBF;AACF;AA0BQ;EACE,aAAA;AAxBV;;AA+BA;EAIQ;IACE,aAAA;EA/BR;EAkCM;IACE,aAAA;EAhCR;EAqCM;IACE,2BAAA;IACA,YAAA;EAnCR;EAsCM;IACE,uBAAA;IACA,iCAAA;EApCR;EAuCM;IACE,aAAA;EArCR;EAwCM;IACE,gBAAA;IACA,WAAA;EAtCR;EAwCQ;IACE,cAAA;IACA,aAAA;IACA,mCAAA;IACA,UA7He;EAuFzB;EAwCU;IACE,sBAAA;IACA,uBAAA;EAtCZ;EAwCY;IACE,UAAA;EAtCd;EAwCc;;IAEE,YAAA;IACA,WAAA;IACA,kBAAA;IACA,8BAAA;IACA,UAAA;EAtChB;EAwCgB;;IACE,yBAAA;EArClB;EA2CU;IACE,MAAA;IACA,oBAAA;IACA,gBAAA;IACA,YAAA;IACA,iBAAA;IACA,iBAAA;EAzCZ;EA6CQ;IACE,oBAAA;EA3CV;AACF","sourcesContent":["$compact-menu-offset-left: 17%;\n\n/* Vertical padding */\n@media (min-width: 960px) {\n  .header {\n    padding-top: 0 !important;\n  }\n}\n\n@media (min-width: 720px) {\n  .btn.btn--text-link.quick-cart__item-remove {\n    margin-left: auto;\n  }\n}\n\n.header__logo {\n  margin-top: 2px !important;\n  margin-bottom: 0 !important;\n  padding-top: var(--mobile-padding-size, 0);\n  padding-bottom: var(--mobile-padding-size, 0);\n\n  &.header--vertical-padding-none {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  &.header--vertical-padding-top-only {\n    padding-bottom: 0;\n  }\n\n  &.header--vertical-padding-bottom-only {\n    padding-top: 0;\n  }\n\n  /* Correct logo (light or dark) will be show when backgorund image color will be inspected trough javascript */\n  .regular-logo {\n    display: none;\n  }\n\n  .logo-visible {\n    display: block;\n  }\n}\n\n/* Always show dark logo if sticky header */\n@mixin show-dark-logo() {\n  .header__logo {\n    .logo-visible {\n      display: none;\n    }\n\n    .regular-logo {\n      &.dark {\n        display: block;\n      }\n    }\n  }\n}\n\nheader:hover {\n  @include show-dark-logo();\n}\n\nheader {\n  &.is-sticky {\n    @include show-dark-logo();\n  }\n}\n\n@media (min-width: 960px) {\n  .header__logo {\n    padding-top: var(--padding-size, 0);\n    padding-bottom: var(--padding-size, 0);\n  }\n}\n\n// logo center, compact menu left\n.header {\n  .drawer-menu {\n    .drawer-menu__bottom {\n      .drawer-menu__contents {\n        .header__links-compact-menu-left {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: 960px) {\n  .header {\n    &.header--layout-logo-center-compact-menu-left {\n      .header__row {\n        &.header__row-desktop {\n          display: none;\n        }\n\n        &.header__row-mobile {\n          display: grid;\n        }\n      }\n\n      .drawer-menu {\n        .drawer-menu__bottom {\n          max-width: var(--max-width);\n          margin: auto;\n        }\n\n        .drawer-menu__panel {\n          background: transparent;\n          padding-top: var(--height-header);\n        }\n\n        #localization_form {\n          display: none;\n        }\n\n        .drawer-menu__contents {\n          overflow: hidden;\n          height: 50%;\n\n          .header__links-compact-menu-left {\n            display: block;\n            height: unset;\n            background: var(--color-background);\n            width: $compact-menu-offset-left;\n\n            .header__links-list {\n              flex-direction: column;\n              align-items: flex-start;\n\n              > li {\n                width: 90%;\n\n                > button,\n                > a {\n                  color: black;\n                  width: 100%;\n                  padding-left: 20px;\n                  justify-content: space-between;\n                  z-index: 1;\n\n                  .header__links-icon {\n                    transform: rotate(270deg);\n                  }\n                }\n              }\n            }\n\n            .meganav {\n              top: 0;\n              left: calc($compact-menu-offset-left) !important;\n              transform: unset;\n              border: none;\n              margin-left: -17%;\n              padding-left: 17%;\n            }\n          }\n\n          .drawer-menu__main {\n            height: 0 !important;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
